import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalSelecionarMapasPage } from './modal-selecionar-mapas.page';

const routes: Routes = [
  {
    path: '',
    component: ModalSelecionarMapasPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalSelecionarMapasPageRoutingModule {}
